module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/is-iterable.js
// module id = 233
// module chunks = 35783957827783 114276838955818